



















































import { Component, Prop, Vue } from "vue-property-decorator";
import iconGameplay from "@/assets/abtest/m1.svg";
import iconTrigger from "@/assets/abtest/m2.svg";
import iconCustom from "@/assets/abtest/m3.svg";
import iconSwitch from "@/assets/abtest/switch.svg";

/** 与后端 FormAbSmartPresetType 对齐 */
export const SMART_AB_PRESET = {
  GAMEPLAY: 1,
  TRIGGER: 2,
  CUSTOM: 3,
  SWITCH: 4,
} as const;

export type SmartAbPresetType = typeof SMART_AB_PRESET[keyof typeof SMART_AB_PRESET];

@Component
export default class SmartAbCreateDialog extends Vue {
  @Prop({ type: Boolean, default: false }) visible!: boolean;
  @Prop({ type: Number, default: 1 }) roundNo!: number;

  get roundBadgeText() {
    const n = this.roundNo || 1;
    return this.$tx("form.smartAb.roundBadge", "第 {n} 轮").replace("{n}", String(n));
  }

  get presets() {
    return [
      {
        type: SMART_AB_PRESET.GAMEPLAY,
        title: this.$tx("form.smartAb.preset.gameplay", "玩法实验测试"),
        desc: this.$tx(
          "form.smartAb.preset.gameplayDesc",
          "快捷设置另一种热门玩法实验，支持人工编辑",
        ),
        icon: iconGameplay,
        dashed: false,
      },
      {
        type: SMART_AB_PRESET.TRIGGER,
        title: this.$tx("form.smartAb.preset.trigger", "触发时机测试"),
        desc: this.$tx(
          "form.smartAb.preset.triggerDesc",
          "测试弹窗的最佳触发时机",
        ),
        icon: iconTrigger,
        dashed: false,
      },
      {
        type: SMART_AB_PRESET.SWITCH,
        title: this.$tx('form.signUpFormOnOff', '订阅工具开关差异'),
        desc: this.$tx('form.testPerformanceDifferencesSignUp', '测试订阅工具是否开启的效果差异'),
        icon: iconSwitch,
        dashed: false,
      },
      {
        type: SMART_AB_PRESET.CUSTOM,
        title: this.$tx("form.smartAb.preset.custom", "自定义实验"),
        desc: this.$tx(
          "form.smartAb.preset.customDesc",
          "默认复制当前模板内容，根据需要灵活调整",
        ),
        icon: iconCustom,
        dashed: true,
      },
    ];
  }

  selectPreset(type: SmartAbPresetType) {
    this.$emit("select", type);
  }

  handleClose() {
    this.$emit("close");
  }
}
